import { render, staticRenderFns } from "./Rulement.vue?vue&type=template&id=0e2c56be&scoped=true"
import script from "./Rulement.vue?vue&type=script&lang=js"
export * from "./Rulement.vue?vue&type=script&lang=js"
import style0 from "./Rulement.vue?vue&type=style&index=0&id=0e2c56be&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e2c56be",
  null
  
)

export default component.exports